var config = {
    tcpaText: "By clicking \"View My Quote\", I am providing my electronic signature and express written consent to receive telemarketing calls, text messages, emails, and postal mail from this website, this website's marketing and re-marketing network, and up to eight insurance companies or their affiliates or representatives (who are identified here) at the phone number xxxxxxxxxx, email address xxxxxxxxxx, and postal address xxxxxxxxxx provided by me. I consent to calls and text messages transmitting insurance quotes, or seeking related information from me, and I agree such contact may be made using an automatic telephone dialing system and/or an artificial or prerecorded voice messages. Additionally, by clicking \"View My Quote\", I acknowledge that I have read, understand, and agree to this Website's Privacy Policy and Terms of Use. Finally, by providing my electronic signature, I acknowledge that giving my consent is not a condition of purchasing any property, goods, or services, and I may revoke my consent at any time.",
    defaultMakes: [ "Acura", "Alfa Romeo", "AM General", "Aston Martin", "Audi", "Bentley", "BMW", "Bugatti", "Buick", "Cadillac", "Chevrolet", "Chrysler", "Daewoo", "Dodge", "Eagle", "Ferrari", "FIAT", "Fisker", "Ford", "Genesis", "Geo", "GMC", "Honda", "HUMMER", "Hyundai", "INFINITI", "Isuzu", "Jaguar", "Jeep", "Kia", "Lamborghini", "Land Rover", "Lexus", "Lincoln", "Lotus", "Maserati", "Maybach", "Mazda", "McLaren", "Mercedes-Benz", "Mercury", "MINI", "Mitsubishi", "Nissan", "Oldsmobile", "Panoz", "Plymouth", "Pontiac", "Porsche", "Ram", "Rolls-Royce", "Saab", "Saturn", "Scion", "smart", "Spyker", "Subaru", "Suzuki", "Tesla", "Toyota", "Volkswagen", "Volvo" ]
};

// try to load settings from AvengeDigitalWidgetSettings
var settings = window.AvengeDigitalWidgetSettings || null;
if (settings) {
    // required
    config.siteId = settings.siteId;
    config.subId = settings.subId;
    config.autoLeadCampaignId = settings.autoLeadCampaignId;
    config.homeLeadCampaignId = settings.homeLeadCampaignId;
    config.apiKey = settings.apiKey;
    config.redirectUrlDefault = settings.redirectUrlDefault;
    config.redirectUrlBase = settings.redirectUrlBase;
    config.redirectUrlOverride = settings.redirectUrlOverride;
    config.redirectUrlOverrideShortForm = settings.redirectUrlOverrideShortForm;
    config.clickListingTypeOverride = settings.clickListingTypeOverride;
    config.privacyPolicyUrl = settings.privacyPolicyUrl;
    config.termsAndConditionsUrl = settings.termsAndConditionsUrl;
    config.partnersUrl = settings.partnersUrl;
    config.callUsPhoneNumber = settings.callUsPhoneNumber;
    config.googleAnalyticsTrackingId = settings.googleAnalyticsTrackingId;
    config.queryLeadInfo = settings.queryLeadInfo;
    config.vinStepAllowSkip = settings.vinStepAllowSkip;
    config.debug = (settings.debug === true);

    // optional
    config.title = settings.title;

    // optional with defaults
    config.requestTimeoutInMilliseconds = settings.requestTimeoutInMilliseconds || 1000 * 5;
    config.localStorageExpirationInMilliseconds = settings.localStorageExpirationInMilliseconds || 1000 * 60 * 60 * 24;
    config.apiUrl = settings.apiUrl || "https://www.avengehub.com";
    config.redirectPath = settings.redirectPath || "/Pre/InsuranceType";
    config.vehicleYearRangeStart = settings.vehicleYearRangeStart || 1990;
    config.vehicleYearRangeEnd = settings.vehicleYearRangeEnd || 2021;
    config.yearMakeModelTrimsUrlBase = settings.yearMakeModelTrimsUrlBase || "https://s3.amazonaws.com/avengedigital.production.widget/VehicleMakeModelTrimsByYear/";
    config.yearMakeModelTrimsFileExtension = settings.yearMakeModelTrimsFileExtension || ".json.gz";
}
// defaults (for testing)
else {
    config.siteId = "testing";
    config.subId = "v1";
    config.redirectUrlDefault = "https://priceshopinsurance.com/thank-you/";
    config.redirectUrlBase = "https://priceshopinsurance.com/";
    config.redirectUrlOverride = "https://priceshopinsurance.com/thank-you-override/";
    config.redirectUrlOverrideShortForm = "https://priceshopinsurance.com/thank-you-override-short/";
    config.clickListingTypeOverride = "MediaAlpha";
    config.privacyPolicyUrl = "https://autohomeinsure.com/contact/";
    config.termsAndConditionsUrl = "https://autohomeinsure.com/contact/";
    config.partnersUrl = "https://priceshopinsurance.com/marketing-partners/";
    //config.title = "Get My Quote";
    config.callUsPhoneNumber = "+16085762305";
    config.googleAnalyticsTrackingId = "UA-156596720-1";
    config.queryLeadInfo = false;
    config.requestTimeoutInMilliseconds = 1000 * 60;
    config.localStorageExpirationInMilliseconds = 1000 * 60; // 1 minute
    config.vinStepAllowSkip = true;
    config.redirectPath = "/Pre/InsuranceType";
    config.vehicleYearRangeStart = 1990;
    config.vehicleYearRangeEnd = 2021;
    config.yearMakeModelTrimsUrlBase = "https://s3.amazonaws.com/avengedigital.test1.widget/VehicleMakeModelTrimsByYear/";
    config.yearMakeModelTrimsFileExtension = ".json.gz";

    if (process.env.NODE_ENV === "production") {
        config.autoLeadCampaignId = 4;
        config.homeLeadCampaignId = 7;
        config.apiUrl = "https://www.avengehub-test1.fun";
        config.apiKey = "6bd8c0df1da040e09d0bd78ab013aa8a";
        config.debug = false;
    }
    else {
        config.autoLeadCampaignId = 5;
        config.homeLeadCampaignId = 12;
        config.apiUrl = "http://localhost:7777";
        //config.apiUrl = "https://www.avengehub-test1.fun:4444";
        config.apiKey = "7c74093f2ba24678908de7c9190dc5b6";
        //config.apiKey = "6bd8c0df1da040e09d0bd78ab013aa8a";
        config.debug = true;
    }
}

export { config }
